import React from "react";
import { Form, Button, Row, Col, Input, message, Modal, FormInstance } from "antd";
import { useAppSelector, useAppDispatch } from "store/hook";
import { useTranslation } from "react-i18next";
import { CharacterVerify } from "../../../Utility/RegExp";
import { setSaveConfigVisible } from "../store/topologySlice";
import { useSaveConfig } from "../queries";
import { deviceNameToID } from "./utils";
import { useRepositoryList } from "Components/DeviceBackup/queries";
import { TableData } from "Utility/Types/status_identity_get_set";

interface SaveConfig {
  construct_submitConfig: (value: any, nodeInf: any) => any;
  form: FormInstance<any>;
  tableData: TableData[];
}

const SaveConfigModal: React.FC<SaveConfig> = React.memo(({ form, tableData, construct_submitConfig }) => {
  const { t } = useTranslation();
  const disp = useAppDispatch();
  const { saveConfigVisible } = useAppSelector((state) => state.topology);
  const { level, loginCid, stateCid } = useAppSelector((state) => state.global);
  const { mutateAsync: saveConfigMutation, isLoading: saveConfigLoading } = useSaveConfig();
  const { data: repositoryList } = useRepositoryList(level, stateCid, loginCid);

  const saveConfig = () => {
    let formData = form.getFieldsValue();

    if (repositoryList?.[0]?.list?.map((item: any) => item.name)?.includes(`${formData.yml_filename}.yml`)) {
      message.error(t("ISMS.Duplicated"));
      return;
    }

    let deviceID = deviceNameToID(tableData, formData.devicesID_or_Name);

    const nodeInf = {
      id: deviceID,
      model: formData.model,
      name: formData.devicesID_or_Name,
    };

    const JSONConfig = construct_submitConfig(formData, nodeInf);

    saveConfigMutation({ level, stateCid, loginCid, JSONConfig, formData })
      .then(() => {
        form.resetFields(["yml_filename"]);
        disp(setSaveConfigVisible(false));

        message.success(t("ISMS.Success"));
      })
      .catch(() => {
        message.error(t("ISMS.Fail"));
      });
  };

  return (
    <Modal
      visible={saveConfigVisible}
      onCancel={() => {
        disp(setSaveConfigVisible(false));
      }}
      destroyOnClose={true}
      centered={true}
      width={"50%"}
      title={t("ISMS.SaveconfigtoRepository")}
      okText="Save"
      footer={[
        <Button key="Cancel" onClick={() => disp(setSaveConfigVisible(false))}>
          {t("ISMS.Cancel")}
        </Button>,
        <Button key="Save" type="primary" loading={saveConfigLoading} onClick={() => saveConfig()}>
          {t("ISMS.Save")}
        </Button>,
      ]}
    >
      <Form form={form} layout="vertical">
        <div className="formwrap">
          <Row gutter={24} justify="start">
            <Col xs={24} sm={24} md={24} lg={12} xl={12}>
              <Form.Item
                name={"yml_filename"}
                label={t("ISMS.FileName")}
                rules={[
                  {
                    required: true,
                    message: "required!",
                  },
                  CharacterVerify,
                ]}
              >
                <Input placeholder={t("ISMS.Inputafilename")} maxLength={30} />
              </Form.Item>
            </Col>
          </Row>
        </div>
      </Form>
    </Modal>
  );
});

export default SaveConfigModal;
